import React from 'react';
import { Field, useFormikContext } from 'formik';

interface BreakTimeComponentProps {
  startWorkingHour?: any;
  endWorkingHour?: any;
}

const BreakTimeComponent: React.FC<BreakTimeComponentProps> = ({ startWorkingHour, endWorkingHour }) => {

  const { setFieldValue, values } = useFormikContext<any>();

  const validateStartBreakingTime = (value: any) => {
    const fromTime = value;
    const toTime = values.breakingTime.toTime;

    if (!fromTime) return "Required";
    if ((values.breakingTime.isAvailable && startWorkingHour) && fromTime <= startWorkingHour) return `From time must be after working hour start time`;
    if ((values.breakingTime.isAvailable && toTime) && fromTime >= toTime) return "From time must be less than To time";
    if ((values.breakingTime.isAvailable && endWorkingHour) && fromTime >= endWorkingHour) return `From time must be before end working hour`;
    return undefined;
  };

  const validateEndBreakingTime = (value: any) => {
    const toTime = value;
    const fromTime = values.breakingTime.fromTime;

    if (!toTime) return "Required";
    if ((values.breakingTime.isAvailable && endWorkingHour) && toTime >= endWorkingHour) return "To time must be before working hour end time";
    if ((values.breakingTime.isAvailable && fromTime) && toTime <= fromTime) return "To time must be greater than From time";
    if ((values.breakingTime.isAvailable && startWorkingHour) && toTime <= startWorkingHour) return "To time must be after start working hour";
    return undefined;
  };
  return (
    <div className="border rounded-lg shadow-md p-3 sm:p-4 bg-white w-full">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 sm:mb-6 gap-2 relative">
        <div className="flex items-center">
          <span className="text-blue-500 mr-2 items-center">⏰</span>
          <h3 className="text-base sm:text-lg font-semibold text-gray-800">Breaking time</h3>
        </div>
        <span className='text-xs text-gray-500 sm:absolute sm:text-[12px] sm:left-[26px] sm:bottom-[-12px] order-3 sm:order-none'>
          The breaking time will be applied to all working days
        </span>
        <div className="flex items-center justify-end sm:justify-start">
          <label className="relative inline-flex items-center cursor-pointer">
            <Field
              type="checkbox"
              name="breakingTime.isAvailable"
              className="sr-only peer"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue("breakingTime.isAvailable", e.target.checked);
              }}
            />
            <div
              className={`w-11 h-6 rounded-full peer transition-colors ${values.breakingTime.isAvailable ? 'bg-blue-600' : 'bg-gray-200'
                }`}
            >
              <div
                className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform ${values.breakingTime.isAvailable ? 'translate-x-5' : 'translate-x-1'
                  } mt-0.5 ml-0.5`}
              ></div>
            </div>
          </label>
        </div>
      </div>

      {/* Time Inputs */}
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full">
        {/* From Time Selector */}
        <div className="flex-1">
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
            <label className="block text-xs sm:text-sm text-gray-600 sm:min-w-[50px]">From</label>
            <div className="relative flex-1">
              <Field
                name="breakingTime.fromTime"
                validate={validateStartBreakingTime}
              >
                {({ field, meta }: any) => (
                  <div className="relative">
                    <input
                      type="time"
                      {...field}
                      disabled={!values.breakingTime.isAvailable}
                      className={`block w-full p-2 text-sm border rounded-lg text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed ${meta.touched && meta.error ? 'border-red-500' : 'border-gray-300'
                        }`}
                    />
                    <div className="h-6 mt-1">
                      {meta.touched && meta.error && (
                        <div className="text-red-500 text-xs absolute whitespace-nowrap overflow-hidden text-ellipsis max-w-full">{meta.error}</div>
                      )}
                    </div>
                  </div>
                )}
              </Field>
            </div>
          </div>
        </div>

        {/* To Time Selector */}
        <div className="flex-1">
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">            <label className="block text-xs sm:text-sm text-gray-600 sm:min-w-[40px]">To</label>
            <div className="relative flex-1">
              <Field
                name="breakingTime.toTime"
                validate={validateEndBreakingTime}
              >
                {({ field, meta }: any) => (
                  <div className="relative">
                    <input
                      type="time"
                      {...field}
                      disabled={!values.breakingTime.isAvailable}
                      className={`block w-full p-2 text-sm border rounded-lg text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed ${meta.touched && meta.error ? 'border-red-500' : 'border-gray-300'
                        }`}
                    />
                    <div className="h-6 mt-1">
                      {meta.touched && meta.error && (
                        <div className="text-red-500 text-xs absolute whitespace-nowrap overflow-hidden text-ellipsis max-w-full">{meta.error}</div>
                      )}
                    </div>
                  </div>
                )}
              </Field>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakTimeComponent;